module.exports = __webpack_public_path__ + "static/media/career-team.644497f6.svg";